import { Button } from '@wheely/ui-kit';
import { useContext, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { IntlContext } from '@/i18n';
import { getCurrentCarId } from '@/modules/car/store/selectors';
import { CountryCode } from '@/shared/models/country-code';
import { MAIN_HOST } from '@/shared/utils/getSiteDomain';

import { CheckPoint } from './CheckPoint';
import s from './styles.module.css';

type Props = {
  onContinueClick: () => void;
};

const createDocsLink = (link: string) => (children: ReactNode) => (
  <Link to={link} target="_blank" rel="noopener noreferrer" className={s.link}>
    {children}
  </Link>
);

const GBDescription = () => {
  const carId = useSelector(getCurrentCarId);

  return (
    <>
      <CheckPoint>
        <FormattedMessage
          tagName="div"
          defaultMessage="Upload your <link1>personal</link1> and <link2>vehicle</link2> documents"
          id="OpmoQQ"
          values={{
            link1: createDocsLink('/profile#docs'),
            link2: createDocsLink(carId ? `/vehicles/${carId}#docs` : '/add-vehicle'),
          }}
          description="Congrats for GB: Documents upload checkpoint"
        />
      </CheckPoint>
      <CheckPoint>
        <FormattedMessage
          defaultMessage="Complete your basic learning test"
          id="kOBx32"
          description="Congrats for GB: Basic learning test checkpoint"
        />
      </CheckPoint>
      <CheckPoint>
        <FormattedMessage
          tagName="div"
          defaultMessage="Book accreditation to start taking journeys"
          id="B6ZBJh"
          description="Congrats for GB: Accreditation booking checkpoint"
        />
      </CheckPoint>
      <CheckPoint>
        <FormattedMessage
          defaultMessage="Complete a set number of journeys to receive up to £2000 sign-up incentive"
          id="WZcJrW"
          description="Congrats for GB: Incentive checkpoint"
        />
      </CheckPoint>
    </>
  );
};

const CongratsView = ({ onContinueClick }: Props) => {
  const { region } = useContext(IntlContext);

  return (
    <div>
      <div>
        <FormattedMessage
          defaultMessage="Your registration is complete."
          id="w4sgoo"
          description="Congrats dialog text"
        />
      </div>

      <div className={s.image} />

      <div>
        <CheckPoint isChecked={true}>
          <FormattedMessage
            defaultMessage="Complete registration"
            id="5Z6s8z"
            description="Congrats checkpoint text"
          />
        </CheckPoint>
        {region === CountryCode.GreatBritain ? (
          <GBDescription />
        ) : (
          <CheckPoint>
            <FormattedMessage
              defaultMessage="Pass accreditation and get access to the Chauffeur app. It usually takes 3-5 days."
              id="QL1B2u"
              description="Congrats checkpoint text"
            />
          </CheckPoint>
        )}
      </div>

      <Button onClick={onContinueClick} className={s.continue}>
        <FormattedMessage defaultMessage="Continue" id="sgXEFE" description="Button text" />
      </Button>

      <div className={s.footnote}>
        <FormattedMessage
          defaultMessage="You can return to process anytime by entering your phone number on <link></link>"
          id="TZTHMp"
          description="Congrats dialog text"
          values={{
            link: () => (
              <a href="/" target="_blank">
                chauffeur.{MAIN_HOST}
              </a>
            ),
          }}
        />
      </div>
    </div>
  );
};

export { CongratsView };
